import { imageFieldUrl, IMAGE_PLACEHOLDER_PATH } from './imageFallback';

/**
 * Resolve a display URL from API image objects or plain strings.
 */
export const resolveImageUrl = (image) => {
  if (!image) return '';
  if (typeof image === 'string') return image.trim();
  return (
    imageFieldUrl(image.original_image) ||
    imageFieldUrl(image.image) ||
    imageFieldUrl(image.thumbnail) ||
    imageFieldUrl(image.medium_image) ||
    imageFieldUrl(image.large_image) ||
    imageFieldUrl(image.image_url) ||
    ''
  );
};

/**
 * Normalize gallery items for ImageLightboxModal: { id, url, alt }.
 */
export const normalizeGalleryImages = (images = [], namePrefix = 'Image') => {
  if (!Array.isArray(images)) return [];
  return images
    .map((image, index) => {
      const url = resolveImageUrl(image);
      if (!url) return null;
      const alt =
        (typeof image === 'object' && (image.title || image.alt || image.name)) ||
        `${namePrefix} ${index + 1}`;
      return {
        id: (typeof image === 'object' && image.id != null ? image.id : null) ?? index,
        url,
        alt,
      };
    })
    .filter(Boolean);
};

export const normalizeUrlList = (urls = [], namePrefix = 'Image') =>
  urls
    .filter(Boolean)
    .map((url, index) => ({
      id: index,
      url: typeof url === 'string' ? url : resolveImageUrl(url),
      alt: `${namePrefix} ${index + 1}`,
    }))
    .filter((slide) => slide.url);

export { IMAGE_PLACEHOLDER_PATH };
